import(/* webpackMode: "eager" */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/CookieConsent.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalLoader"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/GlobalLoader.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalLoggerInit"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/GlobalLoggerInit.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["IdleMount"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/IdleMount.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAInstallBanner"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/layout/PWAInstallBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/components/ui/sonner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/context/AuthContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/context/CartContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteConfigProvider"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/context/SiteConfigContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["VehicleProvider"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/context/VehicleContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["WishlistProvider"] */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/context/WishlistContext.jsx");
